import { WhereClauseCondition } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a WhereClauseCondition.
 *
 * @param value - The value to check.
 * @returns True if the value is a WhereClauseCondition, false otherwise.
 */
export const isWhereClauseCondition = (value: unknown): value is WhereClauseCondition => {
  if (!isObjectRecord(value)) {
    return false;
  }
  // Check strings
  if (!["undefined", "string"].includes(typeof value.dataset)) {
    return false;
  }
  if (!["undefined", "string"].includes(typeof value.variable)) {
    return false;
  }
  if (!["undefined", "string"].includes(typeof value.comparator)) {
    return false;
  }
  // Check value array
  if (
    value.value !== undefined &&
    (!Array.isArray(value.value) || !value.value.every((v) => typeof v === "string"))
  ) {
    return false;
  }
  // Everything is good
  return true;
};
